export default {
  alternate: 'or register a new gym',
  button: {
    create: 'Create a spot',
  },
  spot_selector: {
    title: 'Search a spot',
    fetch: {
      error: 'an error occurred',
    },
    option: {
      nodata: 'unknown spot',
      more: '… and another spot',
      more_other: '… and {{count}} more spots',
    },
  },
  home: {
    lastVisit: 'Visited {{days, relativetime(style: long; range: days; numeric: auto)}}',
    neverVisit: 'Never visited',
  },
}
